import.meta.glob([
  '../images/**/*.{jpg,jpeg,png,svg}',
  '../sprites/**/*.svg',
], {
  query: '?no-inline',
  import: 'default',
  eager: true,
});

import App from './app.js';
App.install();

export { App };